import React from 'react';
import { useDispatch } from 'react-redux';
import { setActiveLayer } from '../../../../../../../redux/toolsSlice';
import { setLayerConfig } from '../../../../../../../redux/stepsSlice';
import './ButtonContent.scss';

// Net-new Button element. Editor + learner share ButtonContentPreview styling.
export const ButtonLayerDefaults = (id) => ({
  id,
  type: 'button',
  content: 'Button label',
  action: 'link',
  destination: '',
  style: 'primary',
  textAlign: 'center',
});

const btnClass = (layer) => `un-pe-btnel un-pe-btnel--${layer.style || 'primary'}`;

// Shared visual used by both the editor canvas and the learner (published) view.
export const ButtonContentPreview = ({ layer, editor = false, onClick }) => {
  const align = layer.textAlign || 'center';
  const label = layer.content || 'Button label';

  if (!editor && layer.action === 'link' && layer.destination) {
    return (
      <div style={{ textAlign: align }}>
        <a className={btnClass(layer)} href={layer.destination} target="_blank" rel="noreferrer">{label}</a>
      </div>
    );
  }
  return (
    <div style={{ textAlign: align }}>
      <span
        className={btnClass(layer)}
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => { if (onClick && e.key === 'Enter') onClick(e); }}
      >
        {label}
      </span>
    </div>
  );
};

function ButtonContent({ layer }) {
  const dispatch = useDispatch();

  const editElement = () => {
    dispatch(setActiveLayer(layer));
    dispatch(setLayerConfig([{ layerId: layer.id, sectionId: 'button', sectionTitle: 'Button', values: [] }]));
  };

  return <ButtonContentPreview layer={layer} editor onClick={editElement} />;
}

export default ButtonContent;
